import { render } from "./PageTitleComponent.vue?vue&type=template&id=479419ca&scoped=true"
const script = {}

import "./PageTitleComponent.vue?vue&type=style&index=0&id=479419ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479419ca"]])

export default __exports__